import React, { Component } from 'react';
import classNames from 'classnames';
import ButtonFace from './buttonFace';
import { playSound } from '../utils/audio';
import { withContext } from '../utils/StateProvider';
import { currentActorId } from '../utils/combat/combatEngine';

// MM3-style combat menu: (A)ttack (S)hoot (C)ast (I)tem (B)lock (R)un
// (Q)uick fight (W)ait
class CombatActionPanel extends Component {
  state = { itemMenu: false };

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  getActor() {
    const id = currentActorId(this.props.context.combat);
    return this.props.context.party.find((c) => c.id === id);
  }

  act = (action, options) => {
    this.setState({ itemMenu: false });
    this.props.context.combatAction(action, options);
  }

  // What the character whose turn it is could drink
  potions() {
    const actor = this.getActor();
    return actor ? actor.backpack.filter((item) => item.restores) : [];
  }

  cycleTarget = () => {
    const { combat, monsters, selectTarget } = this.props.context;
    const foes = monsters.filter((m) => combat.monsterIds.includes(m.id));
    if (foes.length < 2) return;
    // No choice yet (or the chosen foe died) means the first foe is targeted
    const index = Math.max(0, foes.findIndex((m) => m.id === combat.targetId));
    selectTarget(foes[(index + 1) % foes.length].id);
  }

  handleKeydown = (e) => {
    const key = e.key.toLowerCase();
    if (this.state.itemMenu) {
      const potions = this.potions();
      const index = parseInt(key, 10) - 1;
      if (index >= 0 && index < potions.length) {
        this.act('use', { itemId: potions[index].id });
      } else if (key === 'escape') {
        this.setState({ itemMenu: false });
      }
      return;
    }
    if (key === 'i') {
      if (this.potions().length) this.setState({ itemMenu: true });
      return;
    }
    if (key === 'tab') {
      e.preventDefault();
      this.cycleTarget();
      return;
    }
    const actions = { a: 'attack', s: 'shoot', b: 'block', r: 'run', q: 'quick', w: 'wait' };
    if (actions[key]) {
      this.act(actions[key]);
    } else if (key === 'c') {
      this.props.context.beginCast();
    }
  }

  renderButton(label, onClick, disabled = false, icon) {
    return (
      <div key={label} className={classNames('combat', 'action', { disabled, 'has-icon': icon })} onClick={disabled ? undefined : () => { playSound('click'); onClick(); }}>
        <ButtonFace icon={icon} label={label} />
      </div>
    );
  }

  renderItemMenu() {
    const potions = this.potions();
    return (
      <div id="actions" className="combat-menu">
        {this.renderButton('BACK (ESC)', () => this.setState({ itemMenu: false }), false, 'back')}
        {potions.map((potion, index) => this.renderButton(
          `${index + 1}. ${potion.kind.toUpperCase()}`,
          () => this.act('use', { itemId: potion.id }),
        ))}
      </div>
    );
  }

  render() {
    const actor = this.getActor();
    if (!actor) {
      return <div id="actions" className="combat-menu" />;
    }
    if (this.state.itemMenu) return this.renderItemMenu();
    return (
      <div id="actions" className="combat-menu">
        {this.renderButton('(A)TTACK', () => this.act('attack'), false, 'attack')}
        {this.renderButton('(S)HOOT', () => this.act('shoot'), !actor.missile, 'shoot')}
        {this.renderButton('(C)AST', this.props.context.beginCast, !actor.spells.length, 'spell')}
        {this.renderButton('(I)TEM', () => this.setState({ itemMenu: true }), !this.potions().length, 'sleep')}
        {this.renderButton('(B)LOCK', () => this.act('block'), false, 'block')}
        {this.renderButton('(R)UN', () => this.act('run'), false, 'run')}
        {this.renderButton('(Q)UICK FIGHT', () => this.act('quick'), false, 'quick_fight')}
        {this.renderButton('(W)AIT', () => this.act('wait'), false, 'wait')}
      </div>
    );
  }
}

export default withContext(CombatActionPanel);
